module.exports = __webpack_public_path__ + "static/media/SF-16-A.340c058d.mp3";